module.exports = __webpack_public_path__ + "img/missing.4dfdc6c7.svg";